






























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'
import moment from 'moment'
import CDWheelChart from '@/components/communityDevelopment/CDWheelChart.vue'
import CDWheelCenter from '@/components/communityDevelopment/CDWheelCenter.vue'

@Component({
  components: {
    CDWheelChart,
    CDWheelCenter,
  },
})
export default class CDOrganizationWheel extends Vue {
  @Prop({type: GithubOrganizationCollection, required: true})
  organizationCollection!: GithubOrganizationCollection

  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  @Prop({type: GithubRepositoryCommitCollection, default: null})
  repositoryCommitCollection!: GithubRepositoryCommitCollection | null

  @Prop({type: GithubRepositoryCollection, default: null})
  repositoryCollection!: GithubRepositoryCollection | null

  @Prop({type: Object, default: () => ({})})
  commitsByOrganization!: Record<number, number>

  @Prop({type: Number, default: null})
  selectedRepositoryId!: number | null

  get selectedOrganization() {
    const id = this.selectedOrganizationId
    if (id === null) return null
    return this.organizationCollection.items.find(it => it.$id === id) || null
  }

  get selectedRepository() {
    if (this.selectedRepositoryId === null) return null
    return (
      (this.repositoryCollection?.items || []).find(
        it => it.$id === this.selectedRepositoryId
      ) || null
    )
  }

  get sortedOrganizationItems() {
    return [...(this.organizationCollection.items || [])].sort((a, b) => {
      const ca = this.commitsByOrganization[a.$id] ?? 0
      const cb = this.commitsByOrganization[b.$id] ?? 0
      if (cb !== ca) return cb - ca
      return (a.name || a.$tag || '').localeCompare(b.name || b.$tag || '')
    })
  }

  get canNext() {
    const orgs = this.sortedOrganizationItems
    if (!orgs.length) return false
    if (this.selectedOrganizationId === null) return true

    const orgIdx = orgs.findIndex(o => o.$id === this.selectedOrganizationId)
    if (orgIdx < 0) return true

    const repos = this.repositoryCollection?.items || []

    if (this.selectedRepositoryId === null) {
      if (repos.length) return true
      return orgIdx < orgs.length - 1
    }

    const repoIdx = repos.findIndex(r => r.$id === this.selectedRepositoryId)
    if (repoIdx < 0) return true
    if (repoIdx < repos.length - 1) return true
    return orgIdx < orgs.length - 1
  }

  get canPrev() {
    return this.sortedOrganizationItems.length > 0
  }

  get lastUpdateAt(): Date | null {
    const commits = this.repositoryCommitCollection?.items || []

    if (this.selectedRepositoryId !== null) {
      const repo = this.selectedRepository
      if (repo?.lastCommit) {
        const fromRepo = moment(repo.lastCommit)
        if (fromRepo.isValid()) return fromRepo.toDate()
      }
      const repoMoments = commits
        .filter(c => c.githubRepository?.$id === this.selectedRepositoryId)
        .map(c => moment(c.committedAt))
        .filter(m => m.isValid())
      if (repoMoments.length > 0) {
        const repoMax = moment.max(repoMoments)
        if (repoMax.isValid()) return repoMax.toDate()
      }
      if (repo?.updatedAt) {
        const u = moment(repo.updatedAt)
        return u.isValid() ? u.toDate() : null
      }
      return null
    }

    if (this.selectedOrganizationId !== null) {
      const orgId = this.selectedOrganizationId
      const repos = this.repositoryCollection?.items || []
      const repoIds = new Set(repos.map(r => r.$id))

      const fromRepos = repos
        .map(r => moment(r.lastCommit || r.updatedAt))
        .filter(m => m.isValid())
      if (fromRepos.length > 0) {
        const reposMax = moment.max(fromRepos)
        if (reposMax.isValid()) return reposMax.toDate()
      }

      const orgCommitMoments = commits
        .filter(c => {
          const rid = c.githubRepository?.$id
          if (rid == null) return false
          if (repoIds.size > 0) return repoIds.has(rid)
          return c.githubRepository?.githubOrganization?.$id === orgId
        })
        .map(c => moment(c.committedAt))
        .filter(m => m.isValid())
      if (orgCommitMoments.length > 0) {
        const orgCommitMax = moment.max(orgCommitMoments)
        if (orgCommitMax.isValid()) return orgCommitMax.toDate()
      }

      const org = this.selectedOrganization
      if (org?.updatedAt) {
        const u = moment(org.updatedAt)
        return u.isValid() ? u.toDate() : null
      }
      return null
    }

    const allCommitMoments = commits
      .map(c => moment(c.committedAt))
      .filter(m => m.isValid())
    if (allCommitMoments.length > 0) {
      const allMax = moment.max(allCommitMoments)
      return allMax.isValid() ? allMax.toDate() : null
    }
    return null
  }

  selectOrganization(id: number | null) {
    if (id === this.selectedOrganizationId) {
      this.$emit('selectOrganization', null)
      return
    }
    this.$emit('selectOrganization', id)
  }

  onWheelPrev() {
    this.$emit('wheelRepoNavigate', 'prev')
  }

  onWheelNext() {
    this.$emit('wheelRepoNavigate', 'next')
  }
}
